<template>
  <b-col>
    <div class="card-header-actions">
    </div>
    <BreadDirectoriosContent :show-buttons="showButtons" :treeRoutes="routesTree" :records="records" @loadDataDirectorio="loadDataDirectorio" @return-dir="returnDir($event)"></BreadDirectoriosContent>
  </b-col>
</template>
<script>

import BreadDirectoriosContent from "@/components/BreadDirectoriosContent";
import DirectorioService from '@/services/directorio.service';

export default {
  name: "DirectoriosContent",
  components: {
    BreadDirectoriosContent
  },
  props: {
    dataDir: {
      type: Object,
      default: () => {return {}}
    },
    records: {
      type: Array,
      default: () => {return new Array}
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      routesTree: [],
      finalData: [],
    };
  },
  watch: {
    dataDir: function(change) {
      this.routesTree = new Array;
      if(this.dataDir && this.dataDir.tree) {
          this.dataDir.tree.forEach((el,i,a) => {
          let itemData = { text: el.name, rel: el.idDir ? el.idDir : el.name };
          this.routesTree.push(itemData);
          //if(i == a.length - 1) this.$store.dispatch('directorio/setActualTree',this.routesTree);
        });
      }
    }
  },
  methods: {
    returnAction(data) {
      this.$emit("returnAction", data);
    },
    loadDataDirectorio(data) {
      this.routesTree = new Array;
      data.tree.forEach((el,i,a) => {
        let itemData = { text: el.name, rel: el.idDir ? el.idDir : el.name };
        this.routesTree.push(itemData);
        //if(i == a.length - 1) this.$store.dispatch('directorio/setActualTree',this.routesTree);
      });
      this.$emit('change-dir',data);
    },
    returnDir(id) {
      DirectorioService.list(1,{filtro: { _id: id }}).then(dir => {
        this.routesTree = new Array;
        dir[0].tree.forEach((el,i,a) => {
          let itemData = { text: el.name, rel: el.idDir ? el.idDir : el.name };
          this.routesTree.push(itemData);
          //if(i == a.length - 1) this.$store.dispatch('directorio/setActualTree',this.routesTree);
        });
        this.$emit('change-dir',dir[0]);
      });
    }
  }
};
</script>